var _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkflowStatus1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 11,
    viewBox: "0 0 86 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 5.5,
    r: 5.5,
    fill: "#E6E6E6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 5.5,
    r: 5.5,
    fill: "#E6E6E6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 5.5,
    r: 5.5,
    fill: "#E6E6E6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 5.5,
    x2: 18,
    y2: 5.5,
    stroke: "#E6E6E6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 5.5,
    x2: 37,
    y2: 5.5,
    stroke: "#E0E0E0"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 5.5,
    x2: 56,
    y2: 5.5,
    stroke: "#E0E0E0"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: 5.5,
    x2: 75,
    y2: 5.5,
    stroke: "#E0E0E0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 5.5,
    r: 5.5,
    fill: "#E6E6E6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.75,
    stroke: "#FF5777",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowStatus1);
export default __webpack_public_path__ + "static/media/workflow-status-1.55edf1efea1cbd420302c693d2c25c5d.svg";
export { ForwardRef as ReactComponent };